import RoundIcon from "@/Atoms/RoundIcon";
import React from "react";
import BrandFacebook from "@/Atoms/Icons/BrandFacebook";
import Envelope from "@/Atoms/Icons/Envelope";
import BrandWhatsapp from "@/Atoms/Icons/BrandWhatsapp";
import styles from './SharePage.module.scss'
import BrandTwitter from "@/Atoms/Icons/BrandTwitter";
import BrandLinkedIn from "@/Atoms/Icons/BrandLinkedIn";

export default ({url, label}: {
  url: string,
  label?: string,
}) => {




  return <div className={styles.socials}>{label || 'Deel pagina via'}
    <a href={`https://twitter.com/intent/tweet?url=${url}`}>
      <RoundIcon dark icon={< BrandTwitter/>}/>
    </a>
    <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
      <RoundIcon dark icon={< BrandFacebook/>}/>
    </a>
    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`}>
      <RoundIcon dark icon={< BrandLinkedIn/>}/>
    </a>
    <a href={`https://wa.me/?text=${url}`}>
      <RoundIcon dark icon={< BrandWhatsapp/>}/>
    </a>
    <a href={`mailto:?body=${url}`}>
      <RoundIcon dark icon={< Envelope/>}/>
    </a>
  </div>
}
